import { render, staticRenderFns } from "./budget-bid.vue?vue&type=template&id=4547c726&scoped=true"
import script from "./budget-bid.vue?vue&type=script&lang=js"
export * from "./budget-bid.vue?vue&type=script&lang=js"
import style0 from "./budget-bid.vue?vue&type=style&index=0&id=4547c726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547c726",
  null
  
)

export default component.exports